// extracted by mini-css-extract-plugin
export default {"addNewBlock":"NicknameProductItem_addNewBlock__ED0wn","showUp":"NicknameProductItem_showUp__5+caT"};